module.exports = __webpack_public_path__ + "img/kleisma4m.f4b418cd.jpg";